<template>
    <div class="NewLibrariesRequestComponent dataTables">

        <p v-show="isData">{{lang.infotext_1}} <b>{{mainLibraryName}}</b>:</p>
        <div v-show="isData" :id="id"></div>
        <br>
        
        <!-- <LoaderComponent  v-show="!isData"></LoaderComponent> -->

    </div>
</template>
<script>
import LoaderComponent from "@/components/shared/LoaderComponent"
import { mapGetters } from 'vuex'

import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from './../../Tools/Tools'


export default {
    name: "NewLibrariesRequestComponent",
    props: {
        lang: Object,
        reloadTable: Boolean,
        data: Object
    },
    components: {

        LoaderComponent
    },
    data() {
        return {
            name: "NewLibrariesRequestComponent",
            mainTable: "",
            files: [],

            searchTableInput: ""
        }
    },
    computed: {
        ...mapGetters({

            appConf: 'appConf'

        }),
        id() {

            return "place_" + this.name
        },
        isData() {
            return this.files.length != 0
        },
        newRevision() {
            return this.data.newRevisionId == this.data.lockedRevisionId || this.data.newRevisionId == null;
        },
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        },
        mainLibraryName() {
            let jsonName = "";
            let svgName = "";
            let libName = "pushed libraries";
            for (let item in this.data.fileImportResults) {
                
                
                let ext = item.split(".");
                
                if (ext[ext.length - 1].toLowerCase() == "json") {

                    let temp = item.split(".json");
                    
                    jsonName = temp[0];
                }
                if (ext[ext.length - 1].toLowerCase() == "svg") {
                    let temp = item.split(".svg");
                    svgName = temp[0];
                }
                if (jsonName == svgName) {
                    libName = jsonName;
                }
            }
            return libName;
        }
    },
    created() {

    },
    mounted() {

        this.prepareData();
    },
    watch: {

    },
    updated() {


    },
    methods: {
        prepareData() {


            this.files = [];
            let otherLibraries = [];

            for (let item in this.data.fileImportResults) {

                if (this.data.fileImportResults[item].otherLibraries.length > 0) {
                    
                    otherLibraries.push(this.data.fileImportResults[item].otherLibraries)
                }
                
            }
console.log(otherLibraries)
            if (otherLibraries.length > 0) {
                this.files = otherLibraries[0];
                this.buildTable();
            }

        },

        buildTable() {



            let tableplace = document.getElementById(this.id);

            if (tableplace == null) {
                return
            }
            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            let table = document.createElement("table");
            table.setAttribute("id", "t_" + this.id);
            table.setAttribute("class", "table table-striped table-bordered");
            tableplace.appendChild(table)

            let tr = document.createElement("tr");
            tr.setAttribute("class", "cellHeader");
            let thead = document.createElement("thead");
            thead.appendChild(tr);
            table.appendChild(thead);

            let _vue = this;

            let columns = [
                {
                    name: "Id",
                    alignInColumn: "left",

                },
                {
                    name: this.lang.table_header_Name,
                    alignInColumn: "left",

                },
                {
                    name: this.lang.table_header_Type,
                    alignInColumn: "left",

                },
                {
                    name: this.lang.table_header_Status,
                    alignInColumn: "left",

                },
                {
                    name: this.lang.table_header_Files,
                    alignInColumn: "left",

                },


            ]

            let cols = [
                { "data": "revisionId" },
                { "data": "name" },
                { "data": "type" },
                { "data": "status" },
                { "data": "files" },
            ]


            let columnDefs = [];
            let len = columns.length;
            for (let i = 0; i < len; i++) {
                
                

                let classname = '_dt-body-' + columns[i].alignInColumn;

                const el = {
                    targets: i,
                    //width: widthCol,
                    className: classname,

                    render: function ( data, type, row, meta) {
                        if (data == null) {
                            data = "";
                        }

                        data = $.fn.dataTable.render.text().display(data);
                        if (data.display != undefined) {
                            data.display = $.fn.dataTable.render.text().display(data.display);
                        }

                        if (meta.col == 0) {

                            return data;

                        }
                        
                        if (meta.col == 3) {

                            let st = Tools.getStatusColor(data);

                            return "<b-badge class='badge badge-" + st + "'>" + data + "</b-badge>";
                                                        
                        }
                        if (meta.col == 4) {

                            if (data == true) {
                                return "<b-badge class='badge badge-success'>yes</b-badge>";
                            } else {
                                return "<b-badge class='badge badge-danger'>no</b-badge>";
                            }
                        }
                        return data;

                    },


                }

                columnDefs.push(el);



                let th = document.createElement("th");
                tr.appendChild(th);
                let p = document.createElement("p");
                th.appendChild(p);

                let tx = document.createTextNode(columns[i].name)
                p.appendChild(tx);

            }


            const json = {};
            json.paging = true;
            json.info = true;
            json.dom = 'f<t>ip';
            json.data = this.files;
            json.myColumnFormats = columns;
            json.select = false;
            json.order = [[1, "asc"]];
            json.lengthMenu = [16];
            json.columns = cols;

            json.columnDefs = columnDefs;
            json.initComplete = function () {
                console.log("complete")


            }

            if ($.fn.dataTable.isDataTable("#t_" + this.id)) {
                this.mainTable.destroy();

            }



            this.mainTable = $('#t_' + this.id).DataTable(json);

            this.mainTable.columns.adjust().draw();

            //hide first column in table
            this.mainTable.column( 0 ).visible( false );

            //search input change view
            var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

            while (searchplace.firstChild) {

                if (searchplace.firstChild.textContent == "Search:") {
                    searchplace.removeChild(searchplace.firstChild);
                    break;
                }

            }
            searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm");



        }

    }


}
</script>
<style lang="scss">
// @import "./../../scss/_theme.scss";
// @import "./../../scss/_tables.scss";

.NewLibrariesRequestComponent {
    table {
        font-size: 0.75rem;
        padding: 0px !important;
        width: 100% !important;
        margin-right: 10px;

    }

    table th {
        padding: 2px !important;
        
    }

    table th select {
        width: 100% !important;

    }

    table td {
        padding: 0rem !important;

        padding-left: 0.2rem !important;
        padding-right: 0.2rem !important;

    }

    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
        position: absolute;
        top: 20px;
        left: 50%;
        width: 100%;
        height: 20px;
        margin-left: -50%;
        margin-top: 50px;
        padding-top: 5px;
        text-align: center;
        font-size: 1em;

    }

    .dataTables_filter {
        font-size: 10px;
        width: 210px;
    }

    .searcher {
        float: left;
    }

    ._dt-body-left {
        text-align: left;
    }

    ._dt-body-right {
        text-align: right;
    }

    ._dt-body-center {
        text-align: center;
    }

    table {
        .btn {
            padding: 0.15rem 0.5rem;
            margin: 2px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/NewLibrariesRequestComponent.vue